<template>
    <div class="flex items-center justify-end gap-x-2 h-full min-h-[40px] px-2">
        <span class="text-gray-500">{{ label }}:</span>
        <span class="font-semibold" :class="statusClass">{{ $n(allocated) }} / {{ total === null ? '-' : $n(total) }}</span>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    label: string | null;
    allocated: number;
    total: number | null;
}

const props = defineProps<Props>();

/* Green when everything is allocated, red when too little or too much is */
const statusClass = computed(() => {
    if (props.total === null) {
        return 'text-gray-800';
    }
    return props.allocated === props.total ? 'text-green-700' : 'text-red-400';
});
</script>
